module.exports = __webpack_public_path__ + "static/media/Tiffany Plageman Headshot.86f2dae3.png";